import SearchClientProfileEntriesTable from './SearchClientProfileEntriesTable';

export default SearchClientProfileEntriesTable;


// WEBPACK FOOTER //
// ./src/features/client-profile/components/searching/search-form/table/index.js